/* fbcLink.js */

// The Meta pixel sets _fbc asynchronously, so links are only extended at the moment they are used.
const COOKIE_NAME = '_fbc';

function readCookie(name) {
    for (const part of document.cookie.split(';')) {
        const [key, ...value] = part.trim().split('=');

        if (key === name) {
            return decodeURIComponent(value.join('='));
        }
    }

    return '';
}

function isOrganizerLink(url) {
    return url.hostname === 'eventim-light.com' || url.hostname.endsWith('.eventim-light.com');
}

function appendFbc(event) {
    if (!(event.target instanceof Element)) {
        return;
    }

    const link = event.target.closest('a[href]');

    if (!link) {
        return;
    }

    const fbc = readCookie(COOKIE_NAME);

    if (!fbc) {
        return;
    }

    let url;

    try {
        url = new URL(link.href);
    } catch {
        return;
    }

    if (!isOrganizerLink(url) || url.searchParams.has(COOKIE_NAME)) {
        return;
    }

    url.searchParams.append(COOKIE_NAME, fbc);
    link.href = url.href;
}

export default function fbcLink() {
    // auxclick covers middle click, contextmenu covers "open in new tab" and "copy link"
    for (const type of ['click', 'auxclick', 'contextmenu']) {
        document.addEventListener(type, appendFbc, true);
    }
}
